import React from 'react';
import * as Scrivito from 'scrivito';
import { findHomepage } from '../lib/homepage';

// The Rails footer hard-coded the phone number in the template; the `number`
// attribute it nominally belongs to was never filled (its CMS default is a
// copy-paste leftover, "More sites"). Kept as a fallback so the number still
// shows, while an editor can override it.
const FALLBACK_PHONE = '+49 30 8173840';

const Footer = Scrivito.connect(({ page }) => {
  const hp = findHomepage(page);
  if (!hp) return null;

  // Legacy rendered the legal pages from the built-in `toclist`, i.e. the
  // homepage's child pages – not from the `rightsLinks` attribute, which is
  // empty. Reading the wrong one dropped Impressum/Datenschutz and the AGB.
  const legalPages = hp.orderedChildren();
  const email = hp.get('email') || 'info@trans-tech.de';
  const phone = hp.get('number') || FALLBACK_PHONE;

  return (
    <footer className="footer">
      <div className="container">
        <div className="tt-footer__brand">trans-tech</div>
        <div className="row">
          <div className="col-sm-4 margin-b-30">
            <Scrivito.ContentTag tag="h2" attribute="transTechTextHeadline" content={hp} />
            <Scrivito.ContentTag tag="p" attribute="transTechText" content={hp} />
          </div>

          <div className="col-sm-4 margin-b-30">
            <Scrivito.ContentTag tag="h2" attribute="contactUsText" content={hp} />
            <ul className="nopadding">
              <li>
                <span>
                  <i className="ti-map-alt" />
                  <Scrivito.ContentTag tag="span" attribute="adress" content={hp} />
                </span>
              </li>
              <li>
                <span>
                  <i className="ti-email" />
                  <a href={`mailto:${email}`}>{email}</a>
                </span>
              </li>
              <li>
                <span>
                  <i className="ti-headphone-alt" />
                  {phone}
                </span>
              </li>
            </ul>
          </div>

          <div className="col-sm-4 margin-b-30">
            {/* `moreSites` ("RECHTLICHES" / "Legal information") is the label
                editors actually maintain per language; `rightLinksHeadline`
                is an unused, never-translated placeholder ("Further Links"
                on every Homepage) — using it here showed the wrong text.
                Safe as a heading directly: it's a plain `string` attribute,
                so it can't contain block markup the way an `html` one could. */}
            <Scrivito.ContentTag tag="h2" attribute="moreSites" content={hp} />
            <ul className="nopadding">
              {legalPages.map((child) => (
                <li key={child.id()} className="my_list_element">
                  <a href={Scrivito.urlFor(child)}>
                    <span>{child.get('title') || ''}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
          {/* Nested inside the row above, as in the Rails template – that is what
              makes it 15px wider than the columns on each side, so the divider
              line above the copyright runs the full width of the footer. The
              compat layer in main.scss keeps BS5 from treating it as a fourth
              column. */}
          <div className="row">
            <div className="col-sm-12 text-center">
              <div className="footer-bottom">
                {/* Empty in the Rails template as well – apparently meant for social
                    icons. Its list margin is part of the bar's height, so it stays. */}
                <ul className="list-inline" />
                <Scrivito.ContentTag tag="span" attribute="copyRightyText" content={hp} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
});

export default Footer;
